import { Controller } from 'react-hook-form';

import { SizeInputProps } from 'types/api/orders.type';

import { isValidNonNegativeInteger } from 'helpers/isValidNonNegativeInteger';

import * as S from './SizeInput.styles';

const SizeInput = ({ name, control, sizeQuantity, disabled, onBlur }: SizeInputProps) => (
  <S.Wrapper>
    <Controller
      name={name}
      control={control}
      defaultValue={sizeQuantity.quantity}
      render={({ field, fieldState }) => {
        const displayValue = field.value === 0 || field.value === '0' ? '' : field.value;
        return (
          <S.Input
            {...field}
            value={displayValue}
            placeholder="0"
            type="number"
            min={0}
            step={1}
            disabled={disabled}
            $hasError={Boolean(fieldState.error)}
            aria-invalid={Boolean(fieldState.error)}
            title={fieldState.error?.message}
            data-testid={`size-input-${name}`}
            onBlur={(e) => {
              field.onBlur();
              const raw = e.target.value;
              const value = raw.trim() === '' ? '0' : raw;
              if (isValidNonNegativeInteger(value)) {
                onBlur(Number(value));
              }
            }}
          />
        );
      }}
    />
  </S.Wrapper>
);

export { SizeInput };
